'use client';

import { useNavigation } from '@/app/navigation-context';

export function NavLink({ href, target, className, style, showSpinner = false, onNavigate, children, }: {
  href: string;
  target?: string;
  className?: string;
  style?: React.CSSProperties;
  showSpinner?: boolean;
  onNavigate?: () => void;
  children?: React.ReactNode;
}) {
  const { navigate, loadingHref, } = useNavigation();
  const isLoading = showSpinner && loadingHref === href;

  if (target === `_blank`) {
    return <a href={href} target="_blank" className={className} style={style} rel="noreferrer">{children}</a>;
  }

  return (
    <a
      href={href}
      className={className}
      style={{ position: `relative`, ...style, }}
      onClick={(e) => { e.preventDefault(); onNavigate?.(); navigate(href); }}
    >
      {isLoading && (
        <div className="nav-loading-overlay">
          <div className="animate-spin h-8 w-8 border-4 border-white border-t-transparent rounded-full" />
        </div>
      )}
      {children}
    </a>
  );
}
